/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Add event listener to intercept add to cart functionality
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    var _buyButtonContainer$q;
    // Check if the clicked element is an add-to-cart button
    var addToCartButton = event.target.closest('[name="add"]');
    if (!addToCartButton) return;
    var buyButtonContainer = addToCartButton.closest('block-buy-buttons');
    if (!buyButtonContainer) return;

    // Only intercept if it's not already being handled by the custom element
    if (!buyButtonContainer.hasAttribute('data-upsell-product-trigger')) return;

    // Prevent the default button action
    event.preventDefault();
    event.stopPropagation();

    // Dispatch a custom event that the block-buy-buttons component can listen for
    var customEvent = new CustomEvent('customFormSubmit', {
      bubbles: true,
      detail: {
        upsellChecked: Boolean(
          buyButtonContainer.querySelector('input[name="upsell-checkbox"]:checked') ||
          ((_buyButtonContainer$q = buyButtonContainer.querySelector('#upsell-checkbox')) === null || _buyButtonContainer$q === void 0 ? void 0 : _buyButtonContainer$q.checked)
        )
      }
    });

    // Dispatch the event on the buy button container element
    buyButtonContainer.dispatchEvent(customEvent);
  });
});
var CustomSelect = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomSelect, _HTMLElement);
  var _super = _createSuper(CustomSelect);
  function CustomSelect() {
    var _this;
    _classCallCheck(this, CustomSelect);
    _this = _super.call(this);
    _this.customSelect = _this.querySelector("#customSelect");
    _this.button = _this.querySelector("#customSelectButton");
    _this.list = _this.querySelector("#customSelectList");
    _this.selectedValue = _this.querySelector("#selectedValue");
    _this.nativeSelect = _this.querySelector("#nativeSelect");
    _this.options = [];
    _this.currentOptionIndex = -1;
    return _this;
  }
  _createClass(CustomSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Populate options from the light DOM
      var options = Array.from(this.querySelectorAll("option"));
      options.forEach(function (option, index) {
        var li = document.createElement("li");
        var span = document.createElement("span");
        span.textContent = option.textContent;
        li.appendChild(span);
        li.setAttribute("data-value", option.value);
        li.setAttribute("role", "option");
        if (option.hasAttribute("data-product-image-url")) {
          var img = document.createElement("img");
          img.src = option.getAttribute("data-product-image-url");
          img.alt = option.textContent;
          li.prepend(img);
        }
        if (option.hasAttribute("data-url")) {
          li.setAttribute("data-url", option.getAttribute("data-url"));
        }
        if (option.hasAttribute("data-variant-id")) {
          li.setAttribute("data-variant-id", option.getAttribute("data-variant-id"));
        }
        li.tabIndex = -1;
        _this2.list.appendChild(li);
        _this2.nativeSelect.appendChild(option.cloneNode(true));
        _this2.options.push(li);

        // Add event listeners for each option
        li.addEventListener("click", function () {
          if (li.hasAttribute("data-url")) {
            _this2.closeSelect();
            window.location.href = li.getAttribute("data-url");
          } else {
            _this2.selectOption(li);
            _this2.closeSelect();
          }
        });
        li.addEventListener("keydown", function (e) {
          switch (e.key) {
            case "ArrowDown":
              e.preventDefault();
              _this2.focusNextOption();
              break;
            case "ArrowUp":
              e.preventDefault();
              _this2.focusPreviousOption();
              break;
            case "Enter":
            case " ":
              e.preventDefault();
              _this2.selectOption(li);
              _this2.closeSelect();
              break;
            case "Escape":
              e.preventDefault();
              _this2.closeSelect();
              _this2.button.focus();
              break;
          }
        });
      });

      // Add event listeners
      this.button.addEventListener("click", function () {
        _this2.customSelect.classList.contains("open") ? _this2.closeSelect() : _this2.openSelect();
      });
      this.button.addEventListener("keydown", function (e) {
        switch (e.key) {
          case "ArrowDown":
            e.preventDefault();
            if (!_this2.customSelect.classList.contains("open")) _this2.openSelect();
            _this2.focusNextOption();
            break;
          case "ArrowUp":
            e.preventDefault();
            if (!_this2.customSelect.classList.contains("open")) _this2.openSelect();
            _this2.focusPreviousOption();
            break;
          case "Enter":
          case " ":
            e.preventDefault();
            if (_this2.customSelect.classList.contains("open")) {
              _this2.selectOption(_this2.options[_this2.currentOptionIndex]);
              _this2.closeSelect();
            } else {
              _this2.openSelect();
            }
            break;
          case "Escape":
            e.preventDefault();
            _this2.closeSelect();
            break;
        }
      });
      document.addEventListener("click", function (e) {
        if (!_this2.contains(e.target) && !_this2.contains(e.target)) {
          _this2.closeSelect();
        }
      });
    }
  }, {
    key: "openSelect",
    value: function openSelect() {
      this.customSelect.classList.add("open");
      this.button.setAttribute("aria-expanded", "true");
    }
  }, {
    key: "closeSelect",
    value: function closeSelect() {
      this.customSelect.classList.remove("open");
      this.button.setAttribute("aria-expanded", "false");
      this.currentOptionIndex = -1;
    }
  }, {
    key: "focusOption",
    value: function focusOption(index) {
      if (index >= 0 && index < this.options.length) {
        this.options.forEach(function (option) {
          return option.setAttribute("tabindex", "-1");
        });
        this.options[index].setAttribute("tabindex", "0");
        this.options[index].focus();
        this.currentOptionIndex = index;
      }
    }
  }, {
    key: "focusNextOption",
    value: function focusNextOption() {
      var nextIndex = this.currentOptionIndex + 1;
      if (nextIndex >= this.options.length) nextIndex = 0;
      this.focusOption(nextIndex);
    }
  }, {
    key: "focusPreviousOption",
    value: function focusPreviousOption() {
      var prevIndex = this.currentOptionIndex - 1;
      if (prevIndex < 0) prevIndex = this.options.length - 1;
      this.focusOption(prevIndex);
    }
  }, {
    key: "selectOption",
    value: function selectOption(option) {
      var _option$querySelector;
      var value = option.getAttribute("data-value");
      var variantId = option.getAttribute("data-variant-id");
      var price = option.getAttribute("data-price");
      var compareAtPrice = option.getAttribute("data-compare-at-price");

      // Update selected value
      this.selectedValue.textContent = option.textContent;
      this.nativeSelect.value = value;
      this.options.forEach(function (opt) {
        return opt.removeAttribute("aria-selected");
      });
      option.setAttribute("aria-selected", "true");

      // Update the image preview if it exists
      var imgPreview = this.button.querySelector("img");
      var newImageUrl = (_option$querySelector = option.querySelector("img")) === null || _option$querySelector === void 0 ? void 0 : _option$querySelector.src;
      if (imgPreview && newImageUrl) {
        imgPreview.src = newImageUrl;
        imgPreview.alt = option.textContent; // Update alt text as well
      }

      // Update the variant ID in sticky-block-buy-buttons
      var variantInput = this.closest('sticky-product-form').querySelector("form input[name='id']");
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      // Update prices in sr-sticky-atc
      var priceElements = this.closest('sticky-product-form').querySelectorAll(".sticky-atc-price");
      if (priceElements.length > 0 && price) {
        priceElements.forEach(function (priceElement) {
          var priceHTML = '';

          // Check if there's a compare-at price and it's higher than the regular price
          if (compareAtPrice && parseFloat(compareAtPrice.replace(/[^0-9.]/g, '')) > parseFloat(price.replace(/[^0-9.]/g, ''))) {
            priceHTML += "<span class=\"price--compare\">".concat(compareAtPrice, "</span>");
            // Add the price with discount class
            priceHTML += "<span class=\"price--current price-item--off\">".concat(price, "</span>");
          } else {
            // Just the regular price with no discount
            priceHTML += "<span class=\"price--current\">".concat(price, "</span>");
          }

          // Update the price element's HTML
          priceElement.innerHTML = priceHTML;
        });
      }
    }
  }]);
  return CustomSelect;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("custom-select", CustomSelect);

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;